function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.696 48.866l4.932.032m14.504.096L38 49l4 3h11.8v-2h-3.2L45 38l-5 5-5-5h-5.813L27.5 34.2h2.1v2.3h7.2v-2.3H38v5.6l2 2.2V32h-3.2v-2.6h-7.2v2.7h-3l-3.413-7.5h2.72v-2H11.5l.125 12.6H7.812v-3H10.1v-9.6H7.812l.001-4.1-3.5-3.3-1.5 1.4 3 2.9-.032 3.1H3.5v9.6h2.312l.032 3H4.687l-2.562 2.794L2 42 .25 44v4.75l2.942.02M17.4 24.6H21L27 38h-9.6z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(12.49 .567) scale(1.19198)",
  d: "M20.898 40.108a6.187 6.187 0 11-12.375 0 6.187 6.187 0 0112.375 0z",
  strokeWidth: 0.839,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.561 48.375a3.536 3.536 0 11-7.072 0 3.536 3.536 0 017.072 0z",
  strokeWidth: 1.0001600000000002,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.898 40.108a6.187 6.187 0 11-12.375 0 6.187 6.187 0 0112.375 0z",
  transform: "translate(-7.21 .567) scale(1.19198)",
  strokeWidth: 0.839,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.861 48.375a3.536 3.536 0 11-7.072 0 3.536 3.536 0 017.072 0z",
  strokeWidth: 1.0001600000000002,
  strokeLinejoin: "round"
}));

var SvgBulldozer = function SvgBulldozer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulldozer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bulldozer.db3c65de.svg";
export { ForwardRef as ReactComponent };